import { create } from "zustand";
import { PaginationState } from "@tanstack/react-table"; // Para Material React Table
import { AlertSeverityEnum, MaterialTransferido, SerieGeneradoPorENUM } from "@/shared/interfaces";
import { MedidasProductosEnum } from "@/shared/interfaces/erp/inventario";
import { ChangeEvent } from "react";
//import { read, utils, WorkBook } from 'xlsx';
import { getUbicacionProductos, IReingresoSeries, postGenerarSeries, postValidarSeriesDuplicadas, postValidarSeriesEnOrigen } from "@/shared/actions/erp";
import { BucketAwtENUM, cantMaxPermitidoInventariable, esSerieValida, getDuplicates, handleAxiosError, normalizarSerie, OBSERVACION_SERIE_MAX } from "@/shared";
import { useUiStore } from "@/store/ui";

import { IStockFactorSerie } from "@/shared/interfaces/erp/administration/productofactorserie.interface";
import {
  buscarSerieBulk,
  getAllSeries,
  //getStockFactorSerie
} from "@/shared/actions/erp/productofactorserie.actions";
import { v4 as uuidv4 } from 'uuid';
import { toast } from "react-toastify";



type SerieMetrosMap = Record<string, string>;

///* Carga manual (reingreso): una serie por vez, con metros y observacion
///* opcionales cuando el producto va por metros.
export interface DetalleSerieManual {
  serie: string;
  metros?: string;
  observacion?: string;
}

///* Se devuelve al componente para pintar el error bajo el campo correcto.
export interface ResultadoSerieManual {
  ok: boolean;
  campo?: 'serie' | 'metros' | 'observacion';
  mensaje?: string;
}

///* Tope de series de un archivo. Solo se pasa para productos por cantidad
///* (series == cantidad); en metros un archivo puede traer N series.
export interface OpcionesCargaArchivo {
  maxSeries?: number;
}

export interface OpcionesValidacionSeries {
  ///* true: un fallo de red cuenta como problema; si no, las series se
  ///* guardarian sin haberse validado.
  bloquearEnError?: boolean;
}

///* Un producto va por metros si tiene usa_metros o su unidad de medida es
///* METROS. La bandera viaja plana en el ingreso y anidada en los demas flujos.
export const usaMetrosPorSerie = (row: MaterialTransferido | null) =>
  row?.usa_metros === true ||
  row?.producto_data?.usa_metros === true ||
  row?.producto_data?.unidad_medida === MedidasProductosEnum.METROS;

///* TXT y Excel solo traen series: si la lista venia de la carga manual, sus
///* filas de metros/observacion ya no corresponden y se descartan. Los
///* productos factor arman producto_factor por su cuenta (setProductoFactor).
export const filasManualesLimpias = (row: MaterialTransferido | null, esProductoFactor: boolean) =>
  !esProductoFactor && row?.serie_generado_por === SerieGeneradoPorENUM.SELECCION_MANUAL
    ? { producto_factor: [] }
    : {};

///* La carga manual solo aplica a productos con series o por metros.
export const permiteIngresoManual = (row: MaterialTransferido | null) =>
  usaMetrosPorSerie(row) ||
  row?.contiene_serie === true ||
  row?.producto_data?.contiene_serie === true;

///* Cuantas series admite el producto (0 = sin tope). En metros la cantidad
///* es el numero de carretes.
export const topeSeriesManual = (row: MaterialTransferido | null) =>
  Number(row?.cantidad ?? 0);

export function arrayToSerieMetrosTotalsWithGlobal(
  data: IStockFactorSerie[],
): { porSerie: SerieMetrosMap; total: number } {
  const porSerie: SerieMetrosMap = {};
  let total = 0;

  for (const item of data) {
    ///* Carga manual: un carrete sin metros escritos no va en series_metros.
    if (item.cantidad_metros === '' || item.cantidad_metros == null) continue;
    const metros = Number(item.cantidad_metros) || 0;
    //const metros = item.cantidad_metros
    total += metros || 0;

    if (!porSerie[item.serie]) {
      porSerie[item.serie] = "";
    }
    porSerie[item.serie] += metros;
  }

  return { porSerie, total };
}

//**nuevo store */
interface ProductosState {
  productos: MaterialTransferido[];
  setProductos: (productos: MaterialTransferido[]) => void;
  pagination: PaginationState;
  paginatedData: MaterialTransferido[];
  openModalSeries: boolean;
  auxRow: MaterialTransferido | null; // informacion de la fila seleccionada 
  clearSelectedItems: () => void;
  setAuxRow: (auxRow: MaterialTransferido | null) => void;
  setOpenModalSeries: (openModalSeries: boolean) => void;
  //setPaginatedData: (producto: MaterialTransferido[]) => void;
  setPagination: (pagination: PaginationState | ((prev: PaginationState) => PaginationState)) => void;
  handleEliminarProducto: (id: string) => void;
  handleAgregarProducto: (producto: MaterialTransferido, enableAlert?: boolean) => void;
  handleActualizarProducto: (id: string, nuevosValores: Partial<MaterialTransferido>) => void;
  handleFileExcelCustom: (event: ChangeEvent<HTMLInputElement>, keys: string[]) => any;
  handleFileExcel: (event: ChangeEvent<HTMLInputElement>, opts?: OpcionesCargaArchivo) => void
  handleFileTxt: (event: ChangeEvent<HTMLInputElement>, opts?: OpcionesCargaArchivo) => void
  handleGenerarSeries: (key: keyof MaterialTransferido) => void
  handleAgregarUrlSerie: (handleUploadFile: (file: File, type: string) => Promise<{ url: string }>)
    => Promise<MaterialTransferido[] | null>;
  handleAgregarUrlSerieParams: (handleUploadFile: (file: File, type: string) => Promise<{ url: string }>, productos: MaterialTransferido[])
    => Promise<MaterialTransferido[] | null>;
  handleAgregarSeriesArrayProductos: (productos: MaterialTransferido[]) => MaterialTransferido[];
  handleCopiarLista: (producto: MaterialTransferido[]) => void
  handleCopiarListaSeries: (producto: IStockFactorSerie[]) => void
  handleSelectSeriesAutomatico: () => void
  handleSelectManual: (enableAction: boolean) => void
  handleUrlToExcel: (url: string) => Promise<string[]>
  handleUrlToTXT: (url: string) => Promise<string[]>
  handleCleanSeries: () => void;
  handleSeriesManual: (value: string | string[]) => void; ///* logica para las series selecionados manualmente

  ///* Producto asociado bobinas a metraje
  esProductoFactor: boolean;
  setEsProductoFactor: (esProductoFactor: boolean) => void
  productoFactor: IStockFactorSerie[]
  setProductoFactor: () => void
  handleActualizarProductoFactor: (id: string, nuevosValores: IStockFactorSerie) => void;
  handleEliminarProductoFactor: (id: string) => void;
  showAlert: boolean;
  //setShowAlert: (showAlert: boolean) => void;
  //alertasPorproducto: Record<string, boolean>
  //setAlertaPorProducto: (codigo: string, value: boolean) => void,
  isLoadingUbicacionProductos: boolean

  ///* paginador series
  paginationSeries: PaginationState;
  paginatedSeriesData: IStockFactorSerie[];
  setPaginationSeries: (paginationSeries: PaginationState | ((prev: PaginationState) => PaginationState)) => void;

  ///* validación de series duplicadas
  seriesDuplicadas: string[];
  totalDuplicadas: number;
  isValidandoSeries: boolean;
  validarSeriesDuplicadas: (producto: string, series: string[], opts?: OpcionesValidacionSeries) => Promise<boolean>;
  limpiarSeriesDuplicadas: () => void;

  ///* carga manual de series (reingreso)
  agregarSerieManual: (detalle: DetalleSerieManual) => Promise<ResultadoSerieManual>;

  ///* validación de series en origen (para traslado de inventario)
  modoValidacion: 'ingreso' | 'traslado';
  setModoValidacion: (modo: 'ingreso' | 'traslado') => void;
  seriesNoEncontradas: string[];
  totalNoEncontradas: number;
  validarSeriesEnOrigen: (ubicacionOrigen: string, producto: string, series: string[]) => Promise<boolean>;
  limpiarSeriesNoEncontradas: () => void;
  dataReingreso: IReingresoSeries | null;
  setDataReingreso: (dataReingreso: IReingresoSeries | null) => void;

  cantidadSeriesExcel: Record<string, number> | null;
  isLoadingSeriesAll: boolean
}

export const useCargarSeriesProductos = create<ProductosState>((set, get) => ({
  dataReingreso: null,
  setDataReingreso: (dataReingreso) => set({ dataReingreso }),
  isLoadingSeriesAll: false,
  cantidadSeriesExcel: null,
  paginationSeries: { pageIndex: 0, pageSize: 5 },
  paginatedSeriesData: [],
  setPaginationSeries: (paginationSeries) => {
    set((state) => {
      const newPagination = typeof paginationSeries === "function"
        ? paginationSeries(state.paginationSeries)
        : paginationSeries;

      return {
        paginationSeries: newPagination,
        paginatedSeriesData: state.productoFactor.slice(
          newPagination.pageIndex * newPagination.pageSize,
          (newPagination.pageIndex + 1) * newPagination.pageSize
        ),
      };
    });
  },
  ///*
  isLoadingUbicacionProductos: false,
  auxRow: null,
  productos: [],
  pagination: { pageIndex: 0, pageSize: 10 },
  paginatedData: [],
  openModalSeries: false,

  showAlert: false,
  alertasPorproducto: {},
  setProductos: (productos: MaterialTransferido[]) => {
    // La tabla pinta paginatedData, no productos: recalcularla aqui evita el
    // bug visual de que al recargar la pagina (seed del store desde la OT)
    // las filas existan pero no se VEAN hasta la siguiente accion que si la
    // recalculaba (p. ej. agregar otro material). Mismo slice que
    // setPagination/handleAgregarProducto.
    set((state) => ({
      productos,
      paginatedData: productos.slice(
        state.pagination.pageIndex * state.pagination.pageSize,
        (state.pagination.pageIndex + 1) * state.pagination.pageSize
      ),
    }));
  },

  clearSelectedItems() {
    set(() => {
      return {
        pagination: { pageIndex: 0, pageSize: 10 },
        paginatedData: [],
        productos: [],
        auxRow: null
      };
    });
  },
  async setAuxRow(auxRow) {
    /* if (auxRow?.es_producto_factor) {
      set({
        esProductoFactor: auxRow.es_producto_factor,
        productoFactor: auxRow?.producto_factor!
      })
    } */

    get().handleCopiarListaSeries(auxRow?.producto_factor ?? [])

    set({
      auxRow,
      esProductoFactor: auxRow?.es_producto_factor,
    })

    /* let series: string[] = auxRow?.series ?? [];

    if (auxRow?.url_archivo && auxRow.serie_generado_por == SerieGeneradoPorENUM.EXCEL) {
      series = await get().handleUrlToExcel(auxRow.url_archivo);
    }

    if (auxRow?.url_archivo && auxRow.serie_generado_por == SerieGeneradoPorENUM.TXT) {
      series = await get().handleUrlToTXT(auxRow.url_archivo);
    }

    set({
      auxRow: {
        ...auxRow!,
        series,
      }
    }) */
  },
  /* setAlertaPorProducto: (codigo, value) => {
    set((state) => ({
      alertasPorproducto: {
        ...state.alertasPorproducto,
        [codigo]: value
      }
    }))
  }, */
  /* setShowAlert(showAlert) {
    set({ showAlert })
  }, */
  /*  setOpenModalSeries1(openModalSeries1) {
     set({ openModalSeries1 })
 
   }, */
  setOpenModalSeries(openModalSeries) {
    set({ openModalSeries })
  },
  /* setPaginatedData(producto) {
    ///* TODO: Pendiente incorparar, no afecta al flujo
    set((state) => {
      return {
        paginatedData: producto.slice(
          state.pagination.pageIndex * state.pagination.pageSize,
          (state.pagination.pageIndex + 1) * state.pagination.pageSize
        ),
      };
    });
  }, */
  // Establecer la paginación (compatible con Material React Table)
  //**Renderizar paginacion con informacion guardar en memoria */
  setPagination: (pagination) => {
    set((state) => {
      const newPagination = typeof pagination === "function"
        ? pagination(state.pagination)
        : pagination;
      return {
        pagination: newPagination,
        paginatedData: state.productos.slice(
          newPagination.pageIndex * newPagination.pageSize,
          (newPagination.pageIndex + 1) * newPagination.pageSize
        ),
      };
    });
  },

  // Convertir file_temporal en url
  async handleAgregarUrlSerie(handleUploadFile) {

    const productos = get().productos ?? [];

    // Procesar subida de archivos y asignar nuevas URLs
    const nuevasUrlsEntries = await Promise.all(
      productos.map(async (producto) => {
        const url = producto.file_temporal
          ? (await handleUploadFile(producto.file_temporal, BucketAwtENUM.DOCUMENTO_SERIE)).url
          : producto.url_archivo ?? null; // Aseguramos que sea null si no hay URL

        return [producto.codigo, url] as const;
      })
    );

    // Convertir a Map para acceso más rápido
    const nuevasUrlsMap = new Map(nuevasUrlsEntries);

    // Mapear nuevos productos con las URLs asignadas
    /* const newMap = productos.map(({ selected_series, file_temporal, ...rest }) => ({
      ...rest,
      cantidad_metros: arrayToSerieMetrosTotalsWithGlobal(rest.producto_factor ?? []).total,
      series_metros: arrayToSerieMetrosTotalsWithGlobal(rest.producto_factor ?? []).porSerie,
      cantidad: rest.cantidad.toString(),
      series: [
        SerieGeneradoPorENUM.EXCEL,
        SerieGeneradoPorENUM.TXT,
        SerieGeneradoPorENUM.AUTOMATICO,
      ].includes(rest.serie_generado_por!)
        ? []
        : rest.series,
      url_archivo: nuevasUrlsMap.get(rest.codigo) ?? null,
    })); */

    return productos.map(({ selected_series,
      file_temporal,
      metros_actuales, ...rest
    }) => {
      const {
        total,
        porSerie
      } = arrayToSerieMetrosTotalsWithGlobal(
        rest.producto_factor ?? [],
      );

      ///* La observacion de la carga manual viaja en la fila de producto_factor.
      const observaciones_series = Object.fromEntries(
        (rest.producto_factor ?? [])
          .filter(item => item.observacion)
          .map(item => [item.serie, item.observacion!]),
      );

      return {
        ...rest,
        cantidad_metros: total.toString(),
        series_metros: porSerie,
        observaciones_series,
        cantidad: rest.cantidad.toString(),
        producto_factor: null,
        series: [
          SerieGeneradoPorENUM.EXCEL,
          SerieGeneradoPorENUM.TXT,
          SerieGeneradoPorENUM.AUTOMATICO,
        ].includes(rest.serie_generado_por!)
          ? []
          : rest.series,
        url_archivo: nuevasUrlsMap.get(rest.codigo) ?? null,
      };
    });


    /* const productos = get().productos;
    const productosConArchivos = productos.filter(p => p.file_temporal);
    const nuevasUrls = await Promise.all(
      productosConArchivos.map(async (producto) => {
        if (producto.file_temporal) {
          const url = (await handleUploadFile(producto.file_temporal, BucketAwtENUM.DOCUMENTO_SERIE)).url
          return { codigo: producto.codigo, url };
        }
        return { codigo: producto.codigo, url: producto.url_archivo };
      })
    );
    ///ubicacion_origen, ubicacion_destino
    const newProductoData = productos.map(({ selected_series, file_temporal, ...rest }) => {
      const nuevaUrl = nuevasUrls.find(u => u.codigo === rest.codigo)?.url;
      return {
        ...rest,
        cantidad: rest.cantidad.toString(),
        series:
          rest.serie_generado_por == SerieGeneradoPorENUM.EXCEL
            || rest.serie_generado_por == SerieGeneradoPorENUM.TXT
            || rest.serie_generado_por == SerieGeneradoPorENUM.AUTOMATICO
            ? []
            : rest.series,
        url_archivo: nuevaUrl
          ? nuevaUrl
          : rest.url_archivo
            ? rest.url_archivo
            : null,
      }
    })

    return newProductoData ?? []; */
  },


  async handleAgregarUrlSerieParams(handleUploadFile, productos) {


    // Procesar subida de archivos y asignar nuevas URLs
    const nuevasUrlsEntries = await Promise.all(
      productos.map(async (producto) => {
        const url = producto.file_temporal
          ? (await handleUploadFile(producto.file_temporal, BucketAwtENUM.DOCUMENTO_SERIE)).url
          : producto.url_archivo ?? null; // Aseguramos que sea null si no hay URL

        return [producto.codigo, url] as const;
      })
    );

    // Convertir a Map para acceso más rápido
    const nuevasUrlsMap = new Map(nuevasUrlsEntries);

    // Mapear nuevos productos con las URLs asignadas

    return productos.map(({
      selected_series,
      file_temporal,
      metros_actuales,
      ...rest
    }) => {
      /* const {
        total,
        porSerie
      } = arrayToSerieMetrosTotalsWithGlobal(
        rest.producto_factor ?? [],
      ); */

      //const total = Object.values(rest.series_metros ?? {}).reduce((total, valor) => total + Number(valor), 0);
      return {
        ...rest,
        //cantidad_metros: total.toString(),
        //series_metros: porSerie,
        cantidad: rest.cantidad.toString(),
        /* series: [
          SerieGeneradoPorENUM.EXCEL,
          SerieGeneradoPorENUM.TXT,
          SerieGeneradoPorENUM.AUTOMATICO,
        ].includes(rest.serie_generado_por!)
          ? []
          : rest.series, */
        url_archivo: nuevasUrlsMap.get(rest.codigo) ?? null,
      };
    }) ?? [];

  },

  handleAgregarSeriesArrayProductos: (productos: MaterialTransferido[]) => {
    return productos.map(({ selected_series,
      metros_actuales, ...rest
    }) => {
      const {
        total,
        porSerie
      } = arrayToSerieMetrosTotalsWithGlobal(
        rest.producto_factor ?? [],
      );
      if (rest.series && rest.series.length == 0) {
        rest.series = (rest.producto_factor && rest.producto_factor?.length > 0 && rest.producto_factor.map(factor => factor.serie)) || [];
      }
      if (rest.usa_metros) {
        return {
          ...rest,
          cantidad_metros: total.toString(),
          series_metros: porSerie,
          cantidad: rest.cantidad.toString(),
          series: rest.series,
        };
      } else {
        return {
          ...rest,
          cantidad: rest.cantidad.toString(),
          series: rest.series,
        };
      }
    });
  },
  // Eliminar un producto
  handleEliminarProducto: (id) => {
    set((state) => {
      const productosFiltrados = state.productos.filter((producto) => producto.id !== id);
      return {
        productos: productosFiltrados,
        paginatedData: productosFiltrados.slice(
          state.pagination.pageIndex * state.pagination.pageSize,
          (state.pagination.pageIndex + 1) * state.pagination.pageSize
        ),

      };
    });
  },
  // Copiar lista 
  handleCopiarLista(producto) {

    set((state) => {
      return {
        productos: producto,
        paginatedData: producto.slice(
          state.pagination.pageIndex * state.pagination.pageSize,
          (state.pagination.pageIndex + 1) * state.pagination.pageSize
        ),
      };
    });
  },
  handleCopiarListaSeries(productoFactor) {

    set((state) => {
      return {
        //esProductoFactor: productoFactor.length != 0,
        productoFactor: productoFactor,
        paginatedSeriesData: productoFactor.slice(
          state.paginationSeries.pageIndex * state.paginationSeries.pageSize,
          (state.paginationSeries.pageIndex + 1) * state.paginationSeries.pageSize
        ),
      };
    });
  },
  // Agregar un nuevo producto
  handleAgregarProducto: (producto, enableAlert = true) => {

    const setAlert = useUiStore.getState().setAlert;

    if (get().productos.some(element => element.codigo == producto.codigo) && enableAlert)
      return setAlert(true, 'Inventariable previamente agregado.', AlertSeverityEnum.info)

    set((state) => {
      const productosActualizados = [...state.productos, producto];

      return {
        productos: productosActualizados,
        paginatedData: productosActualizados.slice(
          state.pagination.pageIndex * state.pagination.pageSize,
          (state.pagination.pageIndex + 1) * state.pagination.pageSize
        ),
      };
    });

    if (enableAlert)
      setAlert(true, 'Producto agregado correctamente.', AlertSeverityEnum.success)
  },

  // Actualizar un producto por ID
  handleActualizarProducto: (id, nuevosValores) => {

    set((state) => {
      const productosActualizados = state.productos.map((producto) =>
        producto.id === id ? { ...producto, ...nuevosValores } : producto
      );
      return {
        productos: productosActualizados,
        paginatedData: productosActualizados.slice(
          state.pagination.pageIndex * state.pagination.pageSize,
          (state.pagination.pageIndex + 1) * state.pagination.pageSize
        ),

      };
    });
  },

  // Devuelve un array de objetos con el excel cargado
  async handleFileExcelCustom(event, keys: string[]) {

    const file = event.target.files?.[0];
    if (!file) return [];

    try {
      // 1) Leer el archivo como ArrayBuffer mediante promise
      const arrayBuffer = await new Promise<ArrayBuffer>((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
          if (reader.result instanceof ArrayBuffer) resolve(reader.result);
          else reject(new Error('El resultado no es ArrayBuffer'));
        };
        reader.onerror = () => reject(reader.error);
        reader.readAsArrayBuffer(file);
      });

      // 2) Parsear workbook y extraer la primera hoja
      const wb = XLSX.read(arrayBuffer, { type: 'array' });
      const firstSheetName = wb.SheetNames[0];
      if (!firstSheetName) return [];

      const ws = wb.Sheets[firstSheetName];
      console.log(ws)

      // 3) Convertir a JSON usando solo la columna "numero_serie"
      const rows = XLSX.utils.sheet_to_json<any>(ws, {
        header: keys,
      });
      const data = rows.filter((row, i) => {
        if (i != 0) {
          const newObj: any = {};
          keys.forEach((key) => {
            newObj[key] = row[key];
          });
          return newObj;
        }
      });
      return data

    } catch (error) {
      console.error('Error al procesar Excel:', error);
      toast.info('Error al procesar Excel');
      return [];
    }

  },

  // Funcion cargar series desde un archivo excel
  async handleFileExcel(event, opts) {

    const file = event.target.files?.[0];
    if (!file) return;

    try {
      // 1) Leer el archivo como ArrayBuffer mediante promise
      const arrayBuffer = await new Promise<ArrayBuffer>((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
          if (reader.result instanceof ArrayBuffer) resolve(reader.result);
          else reject(new Error('El resultado no es ArrayBuffer'));
        };
        reader.onerror = () => reject(reader.error);
        reader.readAsArrayBuffer(file);
      });

      // 2) Parsear workbook y extraer la primera hoja
      const wb = XLSX.read(arrayBuffer, { type: 'array' });
      const firstSheetName = wb.SheetNames[0];
      if (!firstSheetName) return;

      const ws = wb.Sheets[firstSheetName];

      // 3) Convertir a JSON usando solo la columna "numero_serie"
      const rows = XLSX.utils.sheet_to_json<{ numero_serie: string, cantidad: number }>(ws, {
        header: ['numero_serie', 'cantidad'],
      });

      rows.shift(); // eliminar la cabecera 

      // 4) Extraer el array de series
      const aux = rows.map((r: { numero_serie: string }) => r.numero_serie).filter(Boolean);

      if (aux.length >= cantMaxPermitidoInventariable) {
        toast.info(`El límite máximo permitido es de ${cantMaxPermitidoInventariable} series por cada lote.`)
        return;
      }

      if (opts?.maxSeries !== undefined && aux.length > opts.maxSeries) {
        toast.error(`El archivo trae ${aux.length} series y este producto admite máximo ${opts.maxSeries}.`)
        return;
      }

      const duplicados = getDuplicates(aux);

      if (duplicados.existe_duplicados) {
        set({
          isValidandoSeries: false,
          seriesDuplicadas: duplicados.valores_duplicados,
          totalDuplicadas: duplicados.valores_duplicados.length
        });
        toast.info(`Se encontraron ${duplicados.valores_duplicados.length} series duplicadas`)
        return;
      }

      const safeFile = new File([arrayBuffer], file.name, {
        type: file.type,
        lastModified: file.lastModified,
      });

      // 5) Actualizar el estado una sola vez

      set({
        auxRow: {
          ...get().auxRow!,
          series: aux,
          ...filasManualesLimpias(get().auxRow, get().esProductoFactor),
          file_temporal: safeFile,
          serie_generado_por: SerieGeneradoPorENUM.EXCEL,
          prefijo: null,
        },
      });


      // 6) Validar series según el modo (ingreso = duplicados, traslado = existencia en origen)
      const producto = get().auxRow?.codigo;
      const modoValidacion = get().modoValidacion;
      if (producto && aux.length > 0) {
        if (modoValidacion === 'traslado') {
          // Para traslado: validar que existan en la ubicación de origen
          const ubicacionOrigen = get().auxRow?.ubicacion_origen;
          if (ubicacionOrigen) {
            await get().validarSeriesEnOrigen(ubicacionOrigen, producto, aux);
          }
        } else {
          // Para ingreso: validar que NO existan (duplicados)
          await get().validarSeriesDuplicadas(producto, aux);
        }
      }

      // validar cuando es por serie cargar la cantidad del excel
      if (get().esProductoFactor) {
        const cantidadSeriesExcel = rows.reduce<Record<string, number>>((acc, row) => {
          acc[row.numero_serie] = row.cantidad;
          return acc;
        }, {});

        set({
          cantidadSeriesExcel,
        })

        get().setProductoFactor()
      }
    } catch (error) {
      console.error('Error al procesar Excel:', error);
      toast.info('Error al procesar Excel');
    } finally {
      event.target.value = '';

    }

  },

  // Funcion para cargar series desde un archivo txt
  async handleFileTxt(event, opts) {
    const file = event.target.files?.[0];
    if (!file) return;

    try {
      // 1) Leer el archivo como texto usando Promise
      const content = await new Promise<string>((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
          const text = reader.result;
          if (typeof text === 'string') resolve(text);
          else reject(new Error('El resultado no es texto.'));
        };
        reader.onerror = () => reject(reader.error);
        reader.readAsText(file);
      });

      // 2) Procesar contenido: dividir por líneas y limpiar
      const series = content
        .split(/\r?\n/)           // maneja tanto '\n' como '\r\n'
        .map(line => line.trim()) // quita espacios al inicio/final
        .filter(line => line);    // elimina cadenas vacías

      if (series.length > cantMaxPermitidoInventariable) {
        toast.info(`El límite máximo permitido es de ${cantMaxPermitidoInventariable} series por cada lote.`)
        return;
      }

      if (opts?.maxSeries !== undefined && series.length > opts.maxSeries) {
        toast.error(`El archivo trae ${series.length} series y este producto admite máximo ${opts.maxSeries}.`)
        return;
      }

      const duplicados = getDuplicates(series);

      if (duplicados.existe_duplicados) {
        set({
          isValidandoSeries: false,
          seriesDuplicadas: duplicados.valores_duplicados,
          totalDuplicadas: duplicados.valores_duplicados.length
        });
        toast.info(`Se encontraron ${duplicados.valores_duplicados.length} series duplicadas`)
        return;
      }

      const safeFile = new File([content], file.name, {
        type: file.type || 'text/plain',
        lastModified: file.lastModified,
      });

      // 3) Actualizar estado en una sola llamada
      set({
        auxRow: {
          ...get().auxRow!,
          series,
          ...filasManualesLimpias(get().auxRow, get().esProductoFactor),
          file_temporal: safeFile,
          serie_generado_por: SerieGeneradoPorENUM.TXT,
          prefijo: null,
        },
      });

      if (get().esProductoFactor) {
        get().setProductoFactor()
      }

      // 4) Validar series según el modo (ingreso = duplicados, traslado = existencia en origen)
      const producto = get().auxRow?.codigo;
      const modoValidacion = get().modoValidacion;

      if (producto && series.length > 0) {
        if (modoValidacion === 'traslado') {
          // Para traslado: validar que existan en la ubicación de origen
          const ubicacionOrigen = get().auxRow?.ubicacion_origen;
          if (ubicacionOrigen) {
            await get().validarSeriesEnOrigen(ubicacionOrigen, producto, series);
          }
        } else {
          // Para ingreso: validar que NO existan (duplicados)
          await get().validarSeriesDuplicadas(producto, series);
        }
      }

    } catch (error) {
      console.error('Error al procesar TXT:', error);
      toast.info('Error al procesar TXT');

    } finally {
      event.target.value = '';

    }
  },

  ///* Funcion para generar series automaticas
  //async handleGenerarSeries(key: keyof MaterialTransferido = 'cantidad') {
  async handleGenerarSeries(key: keyof MaterialTransferido = 'cantidad') {

    //convierte a entero cuando es string la cantidad
    const codigo = get().auxRow?.codigo!;
    const aux = get().auxRow;
    const cantidad = Number(aux![key]);

    if (cantidad > cantMaxPermitidoInventariable) {
      toast.info(`El límite máximo permitido es de ${cantMaxPermitidoInventariable} series por cada lote.`)
      return;
    }

    let series = await postGenerarSeries({
      producto: codigo,
      inicio: 1,
      cantidad: cantidad,
      prefijo: `${codigo}-`
    });

    set({
      auxRow: {
        ...get().auxRow!,
        file_temporal: null,
        serie_generado_por: SerieGeneradoPorENUM.AUTOMATICO,
        prefijo: `${codigo}-`,
        series: series.data,
      }
    })
    //get().setShowAlert(true)
    //get().setAlertaPorProducto(codigo, true)
  },

  // seleccionar series automaticas
  async handleSelectSeriesAutomatico() {

    try {
      const auxRow = get().auxRow;

      if (!auxRow) return;

      const resp = await getUbicacionProductos({
        ubicacion: auxRow.ubicacion_origen,
        producto: auxRow.codigo
      });

      const setAlert = useUiStore.getState().setAlert;
      const cantidad = Number(auxRow.cantidad)
      const series = resp.data.data.at(0)?.series ?? []

      if ((series.length + 1) <= cantidad) {
        //get().setShowAlert(false)
        //get().setAlertaPorProducto(auxRow.codigo, false)
        return setAlert(true, 'La cantidad excede al número de series disponibles.', AlertSeverityEnum.info)
      }
      //get().setAlertaPorProducto(auxRow.codigo, true)
      const aux = series.slice(0, cantidad);
      setAlert(true, 'Series seleccionadas automaticamente.', AlertSeverityEnum.success);
      set({
        auxRow: {
          ...get().auxRow!,
          serie_generado_por: SerieGeneradoPorENUM.SELECCION_AUTOMATICO,
          series: aux,
          file_temporal: null,
        }
      })

      ///* obtener producto factor
      get().setProductoFactor();

    } catch (error) {
      handleAxiosError(error)

    }
  },

  // selecionar boton "MANUAL"
  async handleSelectManual(enableAction) {
    try {

      ///* limpiar series
      get().handleCopiarListaSeries([])

      set({
        isLoadingUbicacionProductos: true
      })
      const auxRow = get().auxRow;

      if (!auxRow) return;

      if (enableAction) {

        /* const resp = await getUbicacionProductos({
          ubicacion: auxRow.ubicacion_origen,
          producto: auxRow.codigo
        }); */

        ///* obtener las series por ubicacion y producto al seleccionar manual
        /* const resp = await getAllSeries({
          ubicacion: auxRow.ubicacion_origen,
          producto: auxRow.codigo
        })
        console.log(resp); */

        set({
          isLoadingUbicacionProductos: false,
          auxRow: {
            ...get().auxRow!,
            series: [],
            serie_generado_por: SerieGeneradoPorENUM.SELECCION_MANUAL,
            //selected_series: resp.data.data.at(0)?.series ?? [],

          }
        })

        return;
      }

      set({
        isLoadingUbicacionProductos: false,
        auxRow: {
          ...get().auxRow!,
          series: [],
          serie_generado_por: SerieGeneradoPorENUM.SELECCION_MANUAL,
          selected_series: get().auxRow?.series
        }
      })

      ///* obtener producto factor
      //get().setProductoFactor();

    } catch (error) {
      handleAxiosError(error)
    }

  },
  async handleUrlToExcel(url) {
    try {
      // Obtener el archivo desde la URL
      const response = await fetch(url);
      const arrayBuffer = await response.arrayBuffer();

      // Leer el archivo Excel
      const workbook = XLSX.read(arrayBuffer, { type: "array" });

      // Obtener la primera hoja del archivo
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];

      // Convertir a JSON
      const jsonData: any[] = XLSX.utils.sheet_to_json(sheet, { header: 1 });

      // Extraer la columna de series (suponiendo que están en la primera columna)
      const seriesArray: string[] = jsonData.map((row) => row[0]).filter(Boolean);

      return seriesArray;
    } catch (error) {
      console.error("Error al obtener el archivo Excel:", error);
      return [];
    }
  },
  async handleUrlToTXT(url) {
    try {
      // Obtener el archivo desde la URL
      const response = await fetch(url);

      if (!response.ok) {
        throw new Error(`Error al descargar el archivo: ${response.statusText}`);
      }

      // Leer el contenido del archivo como texto
      const textData = await response.text();

      // Dividir el contenido en líneas y limpiar espacios en blanco
      const seriesArray: string[] = textData
        .split("\n") // Dividir por líneas
        .map(line => line.trim()) // Eliminar espacios en blanco
        .filter(line => line !== ""); // Filtrar líneas vacías

      return seriesArray;
    } catch (error) {
      console.error("Error al obtener el archivo TXT:", error);
      return [];
    }
  },
  handleCleanSeries() {

    set({
      auxRow: {
        ...get().auxRow!,
        series: [],
        file_temporal: null
      },
      productoFactor: []
    })

  },

  handleSeriesManual(value) {

    const {
      auxRow,
      esProductoFactor,
      setAuxRow,
      setProductoFactor
    } = get();

    if (value && value.length <= +auxRow?.cantidad!) {
      setAuxRow({ ...auxRow!, series: value as string[] })

      if (esProductoFactor && !!value.length) {
        setProductoFactor();
      }

    } else {
      toast.info(`Maximo de series admitidas ${auxRow?.cantidad}`)
    }

  },

  async agregarSerieManual({ serie, metros, observacion }) {

    const { auxRow, esProductoFactor, setAuxRow, setProductoFactor } = get();

    if (!auxRow) return { ok: false, campo: 'serie', mensaje: 'Seleccione un producto.' };

    const nueva = normalizarSerie(serie ?? '');

    if (!nueva) return { ok: false, campo: 'serie', mensaje: 'Escriba una serie.' };

    ///* Un pegado de varias series trae justo los separadores prohibidos:
    ///* se rechaza en vez de partirlo.
    if (!esSerieValida(nueva)) {
      return { ok: false, campo: 'serie', mensaje: 'Solo letras y numeros, sin espacios ni simbolos. Ingrese una serie por vez.' };
    }

    const actuales = auxRow.series ?? [];

    if (actuales.includes(nueva)) {
      return { ok: false, campo: 'serie', mensaje: `La serie ${nueva} ya esta cargada.` };
    }

    const tope = topeSeriesManual(auxRow);

    if (tope > 0 && actuales.length >= tope) {
      return { ok: false, campo: 'serie', mensaje: `Maximo de series admitidas ${tope}.` };
    }

    ///* En la carga manual de un producto por metros, los metros son
    ///* obligatorios; solo TXT/Excel ingresan series sin metraje.
    const pideMetros = usaMetrosPorSerie(auxRow);
    const metrosNum = Number(metros);

    if (pideMetros && `${metros ?? ''}`.trim() === '') {
      return { ok: false, campo: 'metros', mensaje: 'Indique los metros de la serie.' };
    }

    if (pideMetros && (!Number.isFinite(metrosNum) || metrosNum <= 0)) {
      return { ok: false, campo: 'metros', mensaje: 'Los metros deben ser un numero mayor a 0.' };
    }

    const nota = pideMetros ? (observacion ?? '').trim() : '';

    if (nota.length > OBSERVACION_SERIE_MAX) {
      return { ok: false, campo: 'observacion', mensaje: `La observacion no puede pasar de ${OBSERVACION_SERIE_MAX} caracteres.` };
    }

    if (get().modoValidacion !== 'traslado') {
      const existe = await get().validarSeriesDuplicadas(auxRow.codigo, [nueva], { bloquearEnError: true });

      get().limpiarSeriesDuplicadas();

      if (existe) {
        return { ok: false, campo: 'serie', mensaje: `La serie ${nueva} ya existe en el sistema.` };
      }

      ///* Mientras se consultaba, el usuario pudo limpiar o cargar un archivo.
      const vigente = get().auxRow;
      if (!vigente || vigente.id !== auxRow.id || (vigente.series?.length ?? 0) !== actuales.length) {
        return { ok: false, campo: 'serie', mensaje: 'La lista cambio mientras se validaba. Intente de nuevo.' };
      }
    }

    const series = [...actuales, nueva];

    ///* En metros cada serie es una fila de producto_factor (serie + metros),
    ///* como en prod: de ahi salen series_metros y cantidad_metros al guardar.
    ///* Las series que ya estaban (de TXT/Excel) entran sin metros.
    const filas = auxRow.producto_factor ?? [];
    const producto_factor = pideMetros
      ? [
        ...actuales.map(s => filas.find(f => f.serie === s)
          ?? { id: uuidv4(), serie: s, peso_factor: 0, cantidad_metros: '' }),
        {
          id: uuidv4(),
          serie: nueva,
          peso_factor: 0,
          ///* Dos decimales porque Series.metros_actuales es Decimal(10, 2).
          cantidad_metros: metrosNum.toFixed(2),
          ...(nota && { observacion: nota }),
        },
      ]
      : auxRow.producto_factor;

    setAuxRow({
      ...auxRow,
      series,
      producto_factor,
      serie_generado_por: SerieGeneradoPorENUM.SELECCION_MANUAL,
      file_temporal: null,
    });

    if (esProductoFactor) {
      setProductoFactor();
    }

    return { ok: true };
  },

  ///*
  esProductoFactor: false,
  setEsProductoFactor(esProductoFactor) {

    set({
      esProductoFactor,
      auxRow: {
        ...get().auxRow!,
        producto_factor: [],
      }
      //productoFactor: [],
      //paginatedSeriesData: []
    })

    get().handleCopiarListaSeries([]);

    ///* obtener producto factor
    /* if (esProductoFactor) {
      get().setProductoFactor();
    } */

  },
  productoFactor: [],
  async setProductoFactor() {

    const series = get().auxRow?.series ?? [];

    try {
      set({
        isLoadingSeriesAll: true
      })

      //const resp = await getAllSeries({
      //  series_in: series.join(','),
      //  ubicacion: get().auxRow?.ubicacion_origen,
      //  producto: get().auxRow?.producto_data?.codigo,
      //  page_size: cantMaxPermitidoInventariable,
      //})

      const resp  = await buscarSerieBulk({
        series: series,
        ubicacion: get().auxRow?.ubicacion_origen,
        producto: get().auxRow?.producto_data?.codigo,
      })

      if (resp.data.total_encontradas == 0) {
        toast.info('No se encontro serie(s) te recomendamos buscar en otra ubicación o registrar un nuevo ingreso de inventario.')
        return;
      }

      const seriesExcelMap = get().cantidadSeriesExcel || {};

      console.log(seriesExcelMap);


      // Mapeamos a la forma que necesitamos
      const productoFactor = resp.data.series_encontradas.map((element) => ({
        serie: element.serie,
        peso_factor: element.metros_actuales,
        //cantidad_metros: String(seriesExcelMap[element.serie] || element.metros_actuales || '0'),
        cantidad_metros: String(seriesExcelMap[element.serie] || '0'),
        id: uuidv4(),
      }));

      set((state) => {
        return {
          productoFactor: productoFactor,
          paginatedSeriesData: productoFactor.slice(
            state.paginationSeries.pageIndex * state.paginationSeries.pageSize,
            (state.paginationSeries.pageIndex + 1) * state.paginationSeries.pageSize
          ),
        };
      });

    } catch (error) {
      console.error('Error al obtener stock factor:', error);
      set({ productoFactor: [] });
    } finally {
      set({
        isLoadingSeriesAll: false
      })
    }
  },

  handleActualizarProductoFactor(id, nuevosValores) {

    /* set((state) => {
      const productosActualizados = state.productoFactor.map((producto) =>
        producto.id === id ? { ...producto, ...nuevosValores } : producto
      );

      return {
        productoFactor: productosActualizados,
      };
    }); */

    set((state) => {
      const productosActualizados = state.productoFactor.map((producto) =>
        producto.id === id ? { ...producto, ...nuevosValores } : producto
      );
      return {
        productoFactor: productosActualizados,
        paginatedSeriesData: productosActualizados.slice(
          state.paginationSeries.pageIndex * state.paginationSeries.pageSize,
          (state.paginationSeries.pageIndex + 1) * state.paginationSeries.pageSize
        ),

      };
    });
  },

  handleEliminarProductoFactor(id) {
    set((state) => {
      const productosFiltrados = state.productoFactor.filter((producto) =>
        producto.id !== id);
      return {
        productoFactor: productosFiltrados,
      };
    });
  },

  ///* validación de series duplicadas
  seriesDuplicadas: [],
  totalDuplicadas: 0,
  isValidandoSeries: false,

  async validarSeriesDuplicadas(producto: string, series: string[], opts) {
    if (!producto || !series || series.length === 0) {
      return false; // No hay duplicados si no hay series
    }

    set({ isValidandoSeries: true });

    try {
      const resultado = await postValidarSeriesDuplicadas({
        producto,
        series,
      });


      if (resultado.tipo_error === 'REINGRESO') {
        toast.error('Se ha detectado un reingreso de series.');
        set({
          openModalSeries: false,
          dataReingreso: {
            tipo_error: 'REINGRESO',
            series_reingreso: resultado.series_reingreso,
            openModal: true,
            referencia_producto: producto,
            nombre_producto: get().auxRow?.producto_data?.descripcion || ''
          },
          isValidandoSeries: false
        });
        return true;
      }

      set({
        seriesDuplicadas: resultado.series_duplicadas,
        totalDuplicadas: resultado.total_duplicadas,
        isValidandoSeries: false,
      });

      if (resultado.tiene_duplicados) {
        toast.error(
          `Se encontraron ${resultado.total_duplicadas} series duplicadas. No se puede continuar con el ingreso.`
        );
      }

      return resultado.tiene_duplicados;
    } catch (error) {
      console.error('Error al validar series duplicadas:', error);
      set({ isValidandoSeries: false });
      toast.error('Error al validar series duplicadas');
      return opts?.bloquearEnError === true;
    }
  },

  limpiarSeriesDuplicadas() {
    set({
      seriesDuplicadas: [],
      totalDuplicadas: 0,
    });
  },

  ///* validación de series en origen (para traslado de inventario)
  modoValidacion: 'ingreso',
  setModoValidacion(modo) {
    set({ modoValidacion: modo });
  },
  seriesNoEncontradas: [],
  totalNoEncontradas: 0,

  async validarSeriesEnOrigen(ubicacionOrigen: string, producto: string, series: string[]) {

    const duplicados = getDuplicates(series);

    if (duplicados.existe_duplicados) {
      set({
        isValidandoSeries: false,
        seriesDuplicadas: duplicados.valores_duplicados,
        totalDuplicadas: duplicados.valores_duplicados.length
      });

      toast.info(`Se han detectado series duplicadas: ${duplicados.valores_duplicados.join(', ')}`);
      return false;
    }

    if (!ubicacionOrigen || !producto || !series || series.length === 0) {
      return true; // No hay problemas si no hay series
    }

    set({ isValidandoSeries: true });

    try {
      const resultado = await postValidarSeriesEnOrigen({
        ubicacion_origen: ubicacionOrigen,
        producto,
        series,
      });

      set({
        seriesNoEncontradas: resultado.series_no_encontradas,
        totalNoEncontradas: resultado.total_no_encontradas,
        isValidandoSeries: false,

      });

      if (!resultado.todas_disponibles) {
        toast.error(
          `Las series que intenta cargar no se encuentran en la ubicacion de origen, total de series no encontradas ${resultado.total_no_encontradas}`
        );

        set({
          auxRow: {
            ...get().auxRow!,
            series: []
          }
        })
      }

      return resultado.todas_disponibles;
    } catch (error) {
      console.error('Error al validar series en origen:', error);
      set({ isValidandoSeries: false });
      toast.error('Error al validar series en la ubicación de origen');
      return true; // En caso de error, permitir continuar
    }
  },

  limpiarSeriesNoEncontradas() {
    set({
      seriesNoEncontradas: [],
      totalNoEncontradas: 0,
    });
  },
}));

